/**
 * 契約API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 連絡先情報
 */
export interface Szoa308aResponseGasAceptSearchResultDtoCncttoInfo {
    /**
     * 事前連絡コード：英数字<br>　コード変換マスターテーブル.画面項目ID「C000690」のユーザコードを設定
     */
    advtelCode?: string;
    /**
     * 事前連絡コード名称：全半角混在
     */
    advtelCodeAname?: string;
}

